import { L10n } from '@skylab-shared/core';
import { enumMap } from './enums-map';


export type EnumValue = string | number;

export interface LabeledEnum {
    [enumValue: string]: LabeledEnumValue;
    [enumValue: number]: LabeledEnumValue;
}

export interface LabeledEnumValue {
    value: EnumValue;
    label: string;
}

export class EnumTranslatorBase {
    public registerEnum(enumType: Object, key: string): void {
        enumMap.set(enumType, key);
    }

    public getLabeledEnum(enumType: Object): LabeledEnum {
        return this.getEnumValues(enumType)
            .reduce((result, enumValue) => (result[enumValue] = this.getLabeledEnumValue(enumType, enumValue), result), <LabeledEnum>{});
    }

    public getLabeledEnumValueArray(enumType: Object): LabeledEnumValue[] {
        return this.getEnumValues(enumType).map(enumValue => this.getLabeledEnumValue(enumType, enumValue));
    }

    public getLabeledEnumValue(enumType: Object, value: EnumValue): LabeledEnumValue {
        const key = this.buildTranslateKey(enumType, value);
        const translation = L10n._T(key);
        return {
            value: value,
            label: translation === key ? '' : translation
        };
    }

    private getEnumValues(enumType: Object): EnumValue[] {
        const isNumberEnum = (type: any) => Object.keys(type).some(key => {
            const num = Number(key);
            return !isNaN(num) && type[type[key]] === num;
        });

        if (isNumberEnum(enumType)) {
            return Object.keys(enumType)
                .map(k => Number(k))
                .filter(k => typeof (k) === 'number' && !isNaN(k));
        } else {
            return Object.keys(enumType)
                .map(k => (enumType as any)[k]);
        }
    }

    private buildTranslateKey(enumType: Object, value: EnumValue): string {
        const mapped = enumMap.get(enumType);
        const key = Object.keys(enumType).find(k => (enumType as any)[k] === value) ?? '';

        return `enums.${mapped}.${key}`;
    }
}

export const NewEnumTranslator = new EnumTranslatorBase();
